import { createAction } from 'redux-actions';
import * as actions from './actions';

// Guest
export const fetchComplaintsRequest = createAction(actions.FETCH_COMPLAINTS_REQUEST);
export const fetchComplaintsSuccess = createAction(actions.FETCH_COMPLAINTS_SUCCESS);
export const fetchComplaintsFailure = createAction(actions.FETCH_COMPLAINTS_FAILURE);

export const fetchComplaintRequest = createAction(actions.FETCH_COMPLAINT_REQUEST);
export const fetchComplaintSuccess = createAction(actions.FETCH_COMPLAINT_SUCCESS);
export const fetchComplaintFailure = createAction(actions.FETCH_COMPLAINT_FAILURE);

export const createComplaintRequest = createAction(actions.CREATE_COMPLAINT_REQUEST);
export const createComplaintSuccess = createAction(actions.CREATE_COMPLAINT_SUCCESS);
export const createComplaintFailure = createAction(actions.CREATE_COMPLAINT_FAILURE);

export const updateComplaintRequest = createAction(actions.UPDATE_COMPLAINT_REQUEST);
export const updateComplaintSuccess = createAction(actions.UPDATE_COMPLAINT_SUCCESS);
export const updateComplaintFailure = createAction(actions.UPDATE_COMPLAINT_FAILURE);

export const withdrawComplaintRequest = createAction(actions.WITHDRAW_COMPLAINT_REQUEST);
export const withdrawComplaintSuccess = createAction(actions.WITHDRAW_COMPLAINT_SUCCESS);
export const withdrawComplaintFailure = createAction(actions.WITHDRAW_COMPLAINT_FAILURE);

export const respondComplaintRequest = createAction(actions.RESPOND_COMPLAINT_REQUEST);
export const respondComplaintSuccess = createAction(actions.RESPOND_COMPLAINT_SUCCESS);
export const respondComplaintFailure = createAction(actions.RESPOND_COMPLAINT_FAILURE);

export const uploadComplaintImageRequest = createAction(actions.UPLOAD_COMPLAINT_IMAGE_REQUEST);
export const uploadComplaintImageSuccess = createAction(actions.UPLOAD_COMPLAINT_IMAGE_SUCCESS);
export const uploadComplaintImageFailure = createAction(actions.UPLOAD_COMPLAINT_IMAGE_FAILURE);

// Host
export const fetchHostComplaintsRequest = createAction(actions.FETCH_HOST_COMPLAINTS_REQUEST);
export const fetchHostComplaintsSuccess = createAction(actions.FETCH_HOST_COMPLAINTS_SUCCESS);
export const fetchHostComplaintsFailure = createAction(actions.FETCH_HOST_COMPLAINTS_FAILURE);

export const fetchHostComplaintRequest = createAction(actions.FETCH_HOST_COMPLAINT_REQUEST);
export const fetchHostComplaintSuccess = createAction(actions.FETCH_HOST_COMPLAINT_SUCCESS);
export const fetchHostComplaintFailure = createAction(actions.FETCH_HOST_COMPLAINT_FAILURE);

export const hostRespondComplaintRequest = createAction(actions.HOST_RESPOND_COMPLAINT_REQUEST);
export const hostRespondComplaintSuccess = createAction(actions.HOST_RESPOND_COMPLAINT_SUCCESS);
export const hostRespondComplaintFailure = createAction(actions.HOST_RESPOND_COMPLAINT_FAILURE);

// Shared
export const complaintConflict = createAction(actions.COMPLAINT_CONFLICT);
export const complaintImageWarning = createAction(actions.COMPLAINT_IMAGE_WARNING);
export const complaintsReset = createAction(actions.COMPLAINTS_RESET);
